import { z } from "zod";

import { TObjectBase } from "../base";
import { TReadAccess } from "../common/readAccess";

// Filter groups:
//  - collections-{collectionID}
//  - collections-{collectionID}-items-{itemID}
export type IViewFilterGroup = z.infer<typeof TViewFilterGroup>;
export const TViewFilterGroup = z.union([
  z.literal("bookingUnits"),
  z.literal("collections"),
  z.literal("contractorTable"),
  z.literal("deviationOverview"),
  z.literal("files"),
  z.literal("propertyTenants"),
  z.literal("routines"),
  z.literal("units"),
]);

export type IViewFilterComparator = z.infer<typeof TViewFilterComparator>;
export const TViewFilterComparator = z.union([
  z.literal("equals"),
  z.literal("not-equals"),
  z.literal("is-one-of"),
  z.literal("is-not-one-of"),
  z.literal("includes"),
  z.literal("contains-all"),
  z.literal("less-than"),
  z.literal("less-than-or-equal-to"),
  z.literal("greater-than"),
  z.literal("greater-than-or-equal-to"),
  z.literal("rolling-back"),
  z.literal("rolling-forward"),
  z.literal("within-period"),
  z.literal("is-known"),
  z.literal("is-unknown"),
]);

export type IViewSortDirection = z.infer<typeof TViewSortDirection>;
export const TViewSortDirection = z.union([
  z.literal("ascending"),
  z.literal("descending"),
]);

export type IViewRowHeight = z.infer<typeof TViewRowHeight>;
export const TViewRowHeight = z.union([
  z.literal("sm"),
  z.literal("md"),
  z.literal("lg"),
]);

export type IViewFilter = z.infer<typeof TViewFilter>;
export const TViewFilter = z.object({
  comparator: TViewFilterComparator,
  data: z.array(z.any()).or(z.any()),
});

export type IRawView = z.infer<typeof TRawView>;
export const TRawView = z
  .object({
    title: z.string(),
    filterGroup: z.string().or(TViewFilterGroup),
    filters: z.record(z.string(), TViewFilter),
    readAccess: TReadAccess.optional(),
    rowHeight: TViewRowHeight.optional(),
    sortDirection: TViewSortDirection.optional(),
    sortKey: z.string().optional(),
    tableKeys: z.array(z.string()).optional(),
    paginationSize: z.number().optional(),
  })
  .extend(TObjectBase.shape);
